import classNames from 'classnames'
import React from 'react'
import styles from './text-area.module.css'

export function TextArea({ className, ...props }) {
    const classObject = classNames(className, styles['text-area'])
    return <textarea className={classObject} {...props} />
}
